import { render, staticRenderFns } from "./noticeRule.vue?vue&type=template&id=55e81d65&scoped=true&"
import script from "./noticeRule.vue?vue&type=script&lang=js&"
export * from "./noticeRule.vue?vue&type=script&lang=js&"
import style0 from "./noticeRule.vue?vue&type=style&index=0&id=55e81d65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e81d65",
  null
  
)

component.options.__file = "noticeRule.vue"
export default component.exports